// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1m2WL","errors":"Errors_errors__4ch6T"};